import passwordValidator from 'password-validator';
const PasswordSchema = new passwordValidator();
PasswordSchema.is()
    .min(8)
    .is()
    .max(24)
    .has()
    .uppercase()
    .has()
    .lowercase()
    .has()
    .digits()
    .has()
    .not()
    .spaces();
import moment from 'moment';

const PortalStatus = {
    NEW: 'NEW',
    REGISTERED: 'REGISTERED',
    SALES_CONFIRMED: 'SALES_CONFIRMED',
    MSA_ACCEPTED: 'MSA_ACCEPTED',
    IMPLEMENTATION: 'IMPLEMENTATION',
    LIVE: 'LIVE',
};

const UserRole = {
    SUPERADMIN: 'super-admin',
    EXEC: 'exec',
    // SALES: 'sales',
    // SUPPORT: 'support',
    SUPERVISOR: 'supervisor',
    USER: 'user',
};

const NewUserRole = {
    SUPERVISOR: 'Admin',
    USER: 'User',
};

const SurchxStatus = {
    INACTIVE: ['NOT_ENABLED', 'ENABLED', 'FREE_TRIAL', 'PROVISIONAL'],
    ACTIVE: ['ACTIVE'],
};

// const Platforms = [
//     'Konnektive',
//     'Magento',
//     'OpenCart',
//     'Shopify',
//     'Shopifyplus',
//     'WooCommerce',
//     '3DCart',
// ]

const Platforms = [
    {
        name: 'Konnektive',
        value: 'Konnektive',
    },
    {
        name: 'Magento',
        value: 'Magento',
    },
    {
        name: 'OpenCart',
        value: 'Open Cart',
    },
    {
        name: 'Shopify',
        value: 'Shopify',
    },
    {
        name: 'Shopifyplus',
        value: 'Shopify+',
    },
    {
        name: 'WooCommerce',
        value: 'WooCommerce',
    },
    {
        name: '3DCart',
        value: '3dcart',
    },
];

const TransactionTypes = [
    'Cancelled',
    'Refunded',
    'Transient',
    'Assigned',
    'Authorized',
    'Captured',
    'Completed',
];

const Processors = ['Stripe', 'Authorize.net'];

const DateRangeOptions = [
    'Today',
    'Yesterday',
    'This week',
    'This month',
    'This quarter',
    'This year',
    'Last week',
    'Last month',
    'Last quarter',
    'Last 6 months',
    'Last year',
];

const US_STATES = [
    {
        name: 'Alabama',
        abbreviation: 'AL',
    },
    {
        name: 'Alaska',
        abbreviation: 'AK',
    },
    {
        name: 'American Samoa',
        abbreviation: 'AS',
    },
    {
        name: 'Arizona',
        abbreviation: 'AZ',
    },
    {
        name: 'Arkansas',
        abbreviation: 'AR',
    },
    {
        name: 'California',
        abbreviation: 'CA',
    },
    {
        name: 'Colorado',
        abbreviation: 'CO',
    },
    {
        name: 'Connecticut',
        abbreviation: 'CT',
    },
    {
        name: 'Delaware',
        abbreviation: 'DE',
    },
    {
        name: 'District Of Columbia',
        abbreviation: 'DC',
    },
    {
        name: 'Federated States Of Micronesia',
        abbreviation: 'FM',
    },
    {
        name: 'Florida',
        abbreviation: 'FL',
    },
    {
        name: 'Georgia',
        abbreviation: 'GA',
    },
    {
        name: 'Guam',
        abbreviation: 'GU',
    },
    {
        name: 'Hawaii',
        abbreviation: 'HI',
    },
    {
        name: 'Idaho',
        abbreviation: 'ID',
    },
    {
        name: 'Illinois',
        abbreviation: 'IL',
    },
    {
        name: 'Indiana',
        abbreviation: 'IN',
    },
    {
        name: 'Iowa',
        abbreviation: 'IA',
    },
    {
        name: 'Kansas',
        abbreviation: 'KS',
    },
    {
        name: 'Kentucky',
        abbreviation: 'KY',
    },
    {
        name: 'Louisiana',
        abbreviation: 'LA',
    },
    {
        name: 'Maine',
        abbreviation: 'ME',
    },
    {
        name: 'Marshall Islands',
        abbreviation: 'MH',
    },
    {
        name: 'Maryland',
        abbreviation: 'MD',
    },
    {
        name: 'Massachusetts',
        abbreviation: 'MA',
    },
    {
        name: 'Michigan',
        abbreviation: 'MI',
    },
    {
        name: 'Minnesota',
        abbreviation: 'MN',
    },
    {
        name: 'Mississippi',
        abbreviation: 'MS',
    },
    {
        name: 'Missouri',
        abbreviation: 'MO',
    },
    {
        name: 'Montana',
        abbreviation: 'MT',
    },
    {
        name: 'Nebraska',
        abbreviation: 'NE',
    },
    {
        name: 'Nevada',
        abbreviation: 'NV',
    },
    {
        name: 'New Hampshire',
        abbreviation: 'NH',
    },
    {
        name: 'New Jersey',
        abbreviation: 'NJ',
    },
    {
        name: 'New Mexico',
        abbreviation: 'NM',
    },
    {
        name: 'New York',
        abbreviation: 'NY',
    },
    {
        name: 'North Carolina',
        abbreviation: 'NC',
    },
    {
        name: 'North Dakota',
        abbreviation: 'ND',
    },
    {
        name: 'Northern Mariana Islands',
        abbreviation: 'MP',
    },
    {
        name: 'Ohio',
        abbreviation: 'OH',
    },
    {
        name: 'Oklahoma',
        abbreviation: 'OK',
    },
    {
        name: 'Oregon',
        abbreviation: 'OR',
    },
    {
        name: 'Palau',
        abbreviation: 'PW',
    },
    {
        name: 'Pennsylvania',
        abbreviation: 'PA',
    },
    {
        name: 'Puerto Rico',
        abbreviation: 'PR',
    },
    {
        name: 'Rhode Island',
        abbreviation: 'RI',
    },
    {
        name: 'South Carolina',
        abbreviation: 'SC',
    },
    {
        name: 'South Dakota',
        abbreviation: 'SD',
    },
    {
        name: 'Tennessee',
        abbreviation: 'TN',
    },
    {
        name: 'Texas',
        abbreviation: 'TX',
    },
    {
        name: 'Utah',
        abbreviation: 'UT',
    },
    {
        name: 'Vermont',
        abbreviation: 'VT',
    },
    {
        name: 'Virgin Islands',
        abbreviation: 'VI',
    },
    {
        name: 'Virginia',
        abbreviation: 'VA',
    },
    {
        name: 'Washington',
        abbreviation: 'WA',
    },
    {
        name: 'West Virginia',
        abbreviation: 'WV',
    },
    {
        name: 'Wisconsin',
        abbreviation: 'WI',
    },
    {
        name: 'Wyoming',
        abbreviation: 'WY',
    },
];

export {
    PortalStatus,
    NewUserRole,
    UserRole,
    Processors,
    SurchxStatus,
    PasswordSchema,
    US_STATES,
    TransactionTypes,
    Platforms,
    DateRangeOptions,
};



// WEBPACK FOOTER //
// ./src/utils/constant.js